import { ValidatorFn } from '@angular/forms';
import { parseApiDate, toNativeDate } from '../function-helper';

export class ValidationUtils {
    static admissionDateRange(getAdmissionDate: () => Date | null): ValidatorFn {
        return control => {
            const admission = getAdmissionDate();
            if (!admission || Number.isNaN(admission.getTime())) {
                return { admissionDateUnavailable: true };
            }
            if (!control.value) {
                return null;
            }
            const selected = toNativeDate(control.value);
            if (!selected || Number.isNaN(selected.getTime())) {
                return { admissionDateRange: true };
            }
            const date = parseApiDate(selected)!;
            const today = parseApiDate(new Date())!;
            return date < admission || date > today ? { admissionDateRange: true } : null;
        };
    }

    static isValidPincode(pincode: string): boolean {
        return /^\d{6}$/.test(pincode.trim()); // (!) for not patten match 
    }

    static isValidContactNumber(contact: string): boolean {
        return /^[1-9]\d{9}$/.test(contact);
    }

    static isValidEmail(email: string): boolean {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email.trim());
    }

    static isAlphabetOnly(value: string): boolean {
        return /^[a-zA-Z]+$/.test(value.trim());
    }
}
